import type { GetInsightInput, Insight, InsightEvaluation, InsightThumbsDownInput, InsightThumbsUpInput } from '@cobliteam/api-lib/src/__generated__/graphql';
import { GraphQLInsightsRequester } from '@cobliteam/api-lib/src/dashboard/insights';
import { useMutation, useQuery } from '@tanstack/react-query';

// Lazy instantiation to avoid circular dependency issues
const getGraphQLInsightsRequester = () => new GraphQLInsightsRequester();

const INSIGHTS_QUERY_KEY = 'INSIGHTS';
const EVALUATION_DOWN_KEY = 'EVALUATION_DOWN';
const EVALUATION_UP_KEY = 'EVALUATION_UP';

const useGetInsights = (input: GetInsightInput) => {
  return useQuery<Insight[]>({
    queryKey: [INSIGHTS_QUERY_KEY, input],
    queryFn: async () => await getGraphQLInsightsRequester().getInsights(input),
  });
};

const useEvaluateInsightThumbsDown = (input: InsightThumbsDownInput) => {
  return useMutation<InsightEvaluation>({
    mutationKey: [INSIGHTS_QUERY_KEY, EVALUATION_DOWN_KEY, input],
    mutationFn: async () => await getGraphQLInsightsRequester().evaluateInsightThumbsDown(input),
  });
};

const useEvaluateInsightThumbsUp = (input: InsightThumbsUpInput) => {
  return useMutation<InsightEvaluation>({
    mutationKey: [INSIGHTS_QUERY_KEY, EVALUATION_UP_KEY, input],
    mutationFn: async () => await getGraphQLInsightsRequester().evaluateInsightThumbsUp(input),
  });
};

export default { useGetInsights, useEvaluateInsightThumbsDown, useEvaluateInsightThumbsUp };
